export default function hasKeyInObject (valueToSearch, objectToSearch) {
  try {
    if (typeof objectToSearch !== 'object') {
      throw new Error('objectToSearch must be an object.')
    }

    return new RegExp(valueToSearch, 'gi').test(JSON.stringify(objectToSearch))
  } catch (e) {
    console.error(e)
    return false
  }
}
